import { render } from "./App.vue?vue&type=template&id=618b6d58"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=618b6d58&lang=scss"

import exportComponent from "H:\\Website\\vglabgamejam2021\\arcanemachine\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__